import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { IndPhrase } from "@shared/models/cat.model";
import { AddInstr } from "@shared/models/common";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { AppState } from "@shared/redux/store";
import { CatService } from "@shared/services/cat.service";
import { TreeNode } from "primeng/api";
import { Popover } from "primeng/popover";
import { CatAddInstrComponent } from "../cat-doc/cat-add-instr/cat-add-instr.component";
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from "@shared/services/shared.service";



@Component({
  selector: 'cat-entry-details-dialog',
  templateUrl: './cat-entry-details-dialog.component.html',
  styleUrls: ['./cat-entry-details-dialog.component.scss'],
  standalone: false
})
export class CatEntryDetailsDialogComponent implements OnInit {

    @Input() editable: boolean = false;
    phrase: IndPhrase = null;

    @Output() onSave = new EventEmitter();
    @Output() onEdit = new EventEmitter();
    @Output() onDelete = new EventEmitter();
    @Output() onClose = new EventEmitter();

    @ViewChild('opTypes') typesOverlay: Popover;
    @ViewChildren(CatAddInstrComponent) instrComponents: QueryList<CatAddInstrComponent>;

    editPhraseText: string;
    loading: boolean = false;
    selectedPhraseType: TreeNode;
    catPhraseTypesTree: TreeNode[];
    editModeSw = false;
    
  constructor(
    private ngRedux: NgRedux<AppState>,
    private catService: CatService,
    private translateService: TranslateService,
    private sharedService: SharedService
  ) {
      
    }
    ngOnInit(): void {
      
      this.phrase = this.ngRedux.getState().curCatElement as IndPhrase;
      
      if (!this.phrase.hasId) {
        this.editModeSw = true;
      }
      this.phrase.saveOriginal();
      this.initCatTypesTree();
      if (this.phrase) {
        this.editPhraseText = this.phrase.phraseText;

    }
      
    }

  isDirty() {

    return this.phrase.isDirty();
    
  }

  initCatTypesTree() {
    if (!this.ngRedux.getState().catPhraseTypeModel) {
      this.catPhraseTypesTree = [];
    } else if (this.phrase.typeCode && this.phrase.subTypeCode) {
      this.catPhraseTypesTree = this.ngRedux
        .getState()
        .catPhraseTypeModel.getTreeBySelectedType(
          this.phrase.typeCode,
          this.phrase.subTypeCode
        );
      this.selectedPhraseType = this.ngRedux
        .getState()
        .catPhraseTypeModel.getSubTypeNode(
          this.catPhraseTypesTree,
          this.phrase.typeCode,
          this.phrase.subTypeCode
        );
    } else {
      this.catPhraseTypesTree =
        this.ngRedux.getState().catPhraseTypeModel.treeTypesForInput;
    }
  }
  onTypeSelected(event: any) {
    this.phrase.typeCode = this.selectedPhraseType.parent.key;
    this.phrase.typeDescr = this.selectedPhraseType.parent.label;
    this.phrase.subTypeCode = this.selectedPhraseType.key;
    this.phrase.subTypeDescr = this.selectedPhraseType.label;
    this.initCatTypesTree();
    if (this.typesOverlay) {
      this.typesOverlay.hide();
    }
  }
  onDeleteInstr(instr: AddInstr) {
    this.phrase.addInstr.splice(this.phrase.addInstr.indexOf(instr), 1);
  }
  addInstr() {
    this.phrase.addInstr.push(new AddInstr());
  }
  onSaveClicked() {
    if (!this.phrase.hasId) {
      this.phrase.phraseText = this.editPhraseText;
      this.catService.createCatEntry(this.phrase).subscribe(
        (data) => {
          this.loading = false;
          this.onSave.emit();
        },
        (err) => (this.loading = false)
      );
    } else {
      // update cat phrase/image
      this.catService.editCatPhrase(this.phrase.phraseId).subscribe(
        (data) => {
          this.catService.updCatEntry(this.phrase).subscribe(
            (data) => {
              this.phrase.saveOriginal();
              this.setInitialEditMode();
              this.instrComponents.forEach((c) => (c.editMode = false));
              this.loading = false;
              this.onEdit.emit();
            },
            (err) => (this.loading = false)
          );
        },
        (err) => (this.loading = false)
      );
    }
  }
  setInitialEditMode() {
    if (this.phrase) {
      this.editPhraseText = this.phrase.phraseText;
      //this.editPhraseTextWords = this.phrase.phraseWords;
      //this.initMergeOptions();
    }

    //this.editModeSw = false;
  }
  onDeleteClicked() {
      let validationStr = this.translateService.instant(
        'translate.cat.deleteEntry'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.loading = true;
          this.catService.deleteCatPhrase(this.phrase.phraseId).subscribe(
            (data) => {
              this.catService.updCatEntry(this.phrase, true).subscribe(
                (data) => {
                  this.loading = false;
                  this.onDelete.emit();
                },
                (err) => (this.loading = false)
              );
            },
            (err) => (this.loading = false)
          );
        },
      });
  }
  validateBeforeSave(): boolean {
    if (this.phrase && !this.editPhraseText) {
      return false;
    } else {
      return true;
    }
  }

  close() {
    if (this.isDirty()) {
      let validationStr = this.translateService.instant(
        'translate.cat.discardEditChanges'
      );

      this.sharedService.emitPopupchReceivedEvent({
        title: 'translate.validation.confirm',
        icon: 'exclamation-triangle',
        subTitle: validationStr,
        keep: false,
        approve: () => {
          this.discardChanges();
          this.onClose.emit();
        },
      });
    } else {
      this.onClose.emit();
    }
  }
  discardChanges() {
    
    this.phrase.restoreOriginal();
    this.setInitialEditMode();
  }


}